module.exports = __webpack_public_path__ + "static/img/image-collage.804eca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/image-collage.png
// module id = u6o9
// module chunks = 2